import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    { attrs: { dense: "" } },
    [
      _c(
        VCol,
        { attrs: { cols: "12", md: "4" } },
        [
          _c(VAutocomplete, {
            staticClass: "mr-2",
            attrs: {
              items: _vm.value.servidores.opcoes,
              chips: "",
              "small-chips": "",
              "deletable-chips": "",
              "item-text": "nomeAvaliado",
              label: "Servidores",
              placeholder: "Digite para pesquisar...",
              multiple: "",
              "prepend-icon": "supervisor_account",
              "return-object": "",
            },
            model: {
              value: _vm.value.servidores.selecionado,
              callback: function ($$v) {
                _vm.$set(_vm.value.servidores, "selecionado", $$v)
              },
              expression: "value.servidores.selecionado",
            },
          }),
        ],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "12", md: "4" } },
        [
          _c(VAutocomplete, {
            staticClass: "mr-2",
            attrs: {
              items: _vm.value.lista.opcoes,
              "item-text": _vm.custom.itemText,
              label: _vm.custom.label,
              "prepend-icon": _vm.custom.icone,
              chips: "",
              "small-chips": "",
              "deletable-chips": "",
              placeholder: "Digite para pesquisar...",
              multiple: "",
              "return-object": "",
            },
            model: {
              value: _vm.value.lista.selecionado,
              callback: function ($$v) {
                _vm.$set(_vm.value.lista, "selecionado", $$v)
              },
              expression: "value.lista.selecionado",
            },
          }),
        ],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "12", md: "4" } },
        [
          _c(VAutocomplete, {
            attrs: {
              items: _vm.value.notas.opcoes,
              chips: "",
              "small-chips": "",
              "deletable-chips": "",
              "item-text": "descricao",
              "item-value": "id",
              label: "Notas",
              placeholder: "Digite para pesquisar...",
              multiple: "",
              "prepend-icon": "grade",
              "return-object": "",
            },
            model: {
              value: _vm.value.notas.selecionado,
              callback: function ($$v) {
                _vm.$set(_vm.value.notas, "selecionado", $$v)
              },
              expression: "value.notas.selecionado",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }